export default "__VITE_ASSET__TUlR96IZ__"